function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Brick from "./brick";
/**
 * @property {string} selector
 * @property {Brick} controller
 * @property {HTMLElement} queryRoot
 */

var BrickFinder = /*#__PURE__*/function () {
  /**
   * @param {string} selector
   * @param {HTMLElement} scope
   * @param {Brick} controller
   * @param {Function} func
   */
  function BrickFinder(selector, scope, controller) {
    var _this = this;

    var func = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, BrickFinder);

    this.selector = selector;
    this.controller = controller;
    this.queryRoot = scope;
    if (func) this.each(func);
    this.on = {
      click: function click(handler) {
        var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return _this.listen('click', handler, debounce);
      },
      contextMenu: function contextMenu(handler) {
        var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return _this.listen('contextmenu', handler, debounce);
      },
      dblclick: function dblclick(handler) {
        var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return _this.listen('dblclick', handler, debounce);
      },
      wheel: function wheel(handler) {
        var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return _this.listen('wheel', handler, debounce);
      },
      submit: function submit(handler) {
        var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return _this.listen('submit', handler, debounce);
      },
      input: function input(handler) {
        var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return _this.listen('input', handler, debounce);
      },
      change: function change(handler) {
        var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return _this.listen('change', handler, debounce);
      },
      clipboard: {
        paste: function paste(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('paste', handler, debounce);
        },
        cut: function cut(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('cut', handler, debounce);
        },
        copy: function copy(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('copy', handler, debounce);
        }
      },
      touch: {
        start: function start(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('touchstart', handler, debounce);
        },
        end: function end(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('touchend', handler, debounce);
        },
        move: function move(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('touchmove', handler, debounce);
        },
        cancel: function cancel(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('touchcancel', handler, debounce);
        }
      },
      mouse: {
        down: function down(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('mousedown', handler, debounce);
        },
        enter: function enter(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('mouseenter', handler, debounce);
        },
        leave: function leave(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('mouseleave', handler, debounce);
        },
        over: function over(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('mouseover', handler, debounce);
        },
        up: function up(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('mouseup', handler, debounce);
        },
        click: function click(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('click', handler, debounce);
        },
        contextMenu: function contextMenu(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('contextmenu', handler, debounce);
        },
        dblclick: function dblclick(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('dblclick', handler, debounce);
        },
        wheel: function wheel(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('wheel', handler, debounce);
        }
      },
      key: {
        down: function down(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('keydown', handler, debounce);
        },
        press: function press(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('keypress', handler, debounce);
        },
        up: function up(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('keyup', handler, debounce);
        }
      },
      focus: {
        focus: function focus(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('focus', handler, debounce);
        },
        in: function _in(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('focusin', handler, debounce);
        },
        out: function out(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('focusout', handler, debounce);
        },
        blur: function blur(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('blur', handler, debounce);
        }
      },
      drag: {
        drag: function drag(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('drag', handler, debounce);
        },
        end: function end(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('dragend', handler, debounce);
        },
        enter: function enter(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('dragenter', handler, debounce);
        },
        leave: function leave(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('dragleave', handler, debounce);
        },
        over: function over(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('dragover', handler, debounce);
        },
        start: function start(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('dragstart', handler, debounce);
        },
        drop: function drop(handler) {
          var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return _this.listen('drop', handler, debounce);
        }
      }
    };
  }
  /**
   * @returns {Element | null}
   */


  _createClass(BrickFinder, [{
    key: "node",
    get: function get() {
      if (this.selector === null) return this.queryRoot;
      var elements;

      try {
        elements = this.queryRoot.querySelectorAll(this.selector);
      } catch (e) {
        return null;
      }

      for (var i in elements) {
        var _elements$i, _elements$i$parentEle;

        if (((_elements$i = elements[i]) === null || _elements$i === void 0 ? void 0 : (_elements$i$parentEle = _elements$i.parentElement) === null || _elements$i$parentEle === void 0 ? void 0 : _elements$i$parentEle.closest('[is]').controller) === this.controller) return elements[i];
      }

      return null;
    }
    /**
     * @returns {Brick | null}
     */

  }, {
    key: "brick",
    get: function get() {
      var element = this.node;
      return element && element.hasOwnProperty('controller') ? element.controller : null;
    }
    /**
     * @param {Function} func
     * @returns {Element | null}
     */

  }, {
    key: "first",
    value: function first(func) {
      var node = this.node;
      if (node) func(node);
      return node;
    }
    /**
     * @returns {Element[]}
     */

  }, {
    key: "nodes",
    get: function get() {
      var _this2 = this;

      if (this.selector === null) return [this.queryRoot];
      var elements;

      try {
        elements = this.queryRoot.querySelectorAll(this.selector);
      } catch (e) {
        return [];
      }

      return Array.prototype.filter.call(elements, function (element) {
        return element.parentNode.closest('[is]').controller === _this2.controller;
      });
    }
    /**
     * @param {Function} func
     * @returns {Element[]}
     */

  }, {
    key: "each",
    value: function each(func) {
      var nodes = this.nodes;
      nodes.forEach(function (node) {
        return func(node);
      });
      return nodes;
    }
    /**
     * @param {string | Array<string>} events
     * @param {Function} handler
     * @param {number} debounce
     * @returns {BrickFinder}
     */

  }, {
    key: "listen",
    value: function listen(events, handler) {
      var debounce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if (typeof events === 'string') events = [events];
      this.each(function (element) {
        events.forEach(function (eventType) {
          if (debounce !== 0 && typeof debounce === 'number') {
            var debouncer = new Debouncer(handler, debounce);

            handler = function handler(event, target) {
              return debouncer.trigger(event, target);
            };
          }

          element.addEventListener(eventType, function (event) {
            return handler(event, element);
          });
        });
      });
      return this;
    }
  }, {
    key: "click",
    value: function click(handler) {
      var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.listen('click', handler, debounce);
    }
  }, {
    key: "contextMenu",
    value: function contextMenu(handler) {
      var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.listen('contextmenu', handler, debounce);
    }
    /**
     * @param {HTMLElement} scope
     * @param {Function} func
     * @returns {BrickFinder}
     */

  }, {
    key: "scope",
    value: function scope(_scope) {
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return new BrickFinder(this.selector, _scope, this.controller, func);
    }
    /**
     * @param {string} filter
     * @param {Function} func
     * @returns {BrickFinder}
     */

  }, {
    key: "filter",
    value: function filter(_filter) {
      var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var bases = this.selector.split(',');

      var filters = _filter.split(',');

      var selector = [];

      for (var i in bases) {
        for (var j in filters) {
          selector.push(bases[i] + filters[j]);
        }
      }

      selector = selector.join(',');
      return new BrickFinder(selector, this.queryRoot, this.controller, func);
    }
  }]);

  return BrickFinder;
}();

export { BrickFinder as default };

var Debouncer = /*#__PURE__*/function () {
  function Debouncer(callback, wait) {
    _classCallCheck(this, Debouncer);

    this.callback = callback;
    this.wait = wait;
  }

  _createClass(Debouncer, [{
    key: "trigger",
    value: function trigger(event, target) {
      var _this3 = this;

      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        return _this3.callback(event, target);
      }, this.wait);
    }
  }]);

  return Debouncer;
}();